import React from "react";
import { PixConfirmationTemplate } from "../../Templates/PixConfirmationTemplate";

export const PixConfirmation = () => {
  return <PixConfirmationTemplate />;
};
